
/**
 * 基本檔: 問卷基本檔.xlsx 的 一行 * 
 */
export class HisBasic {
  檢查日期: string = "";
  公司編號: string = "";
  作業編號: string = "";
  身份證號: string = "";

  性別: string = "";
  姓名: string = "";
  生日: string = "";
  受雇日期: string = "";

}














